export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-extrabold text-foreground-950 text-center mb-3">
          投稿爆料
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          有料你就来，一起吃瓜一起嗨
        </p>
        <div className="max-w-2xl mx-auto">
          <div className="bg-background-100 rounded-2xl border border-background-200/80 p-8 md:p-10 text-center">
            <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-primary-100 flex items-center justify-center">
              <i className="ri-send-plane-fill text-primary-500 text-2xl"></i>
            </div>
            <h3 className="text-lg font-heading font-bold text-foreground-900 mb-3">爆料投稿 · 商务合作</h3>
            <p className="text-sm text-foreground-600 leading-relaxed mb-6 max-w-md mx-auto">
              你有独家吃瓜素材？想分享网红最新动态？欢迎投稿爆料！无论是台北娜娜、玩偶姐姐还是莫里秀相关内容，我们都在等你的第一手消息。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="#"
                className="w-full sm:w-auto px-6 py-3 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-all text-sm whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-line mr-2"></i>发送投稿
              </a>
              <a
                href="#"
                className="w-full sm:w-auto px-6 py-3 bg-background-50 text-foreground-700 font-medium rounded-full hover:bg-background-200 transition-all text-sm border border-background-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-wechat-line mr-2"></i>微信联系
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}